import { render, staticRenderFns } from "./CustomerActivityRepair.vue?vue&type=template&id=f65a8150&"
import script from "./CustomerActivityRepair.vue?vue&type=script&lang=js&"
export * from "./CustomerActivityRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports